/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import env from './env';
const EXP_CONSTS = {
    ...env,
    // CLIENT_ID: "sWzPLSMPFeOaO4N5TJ08j3L4oCnQd41I",
    // IES_BASE_URL: "https://login-stg.pearson.com/v1/piapi-int/"
    TAB_VAL: {'grades': 0, 'questions': 1, 'topics': 2, 'skills': 3},
    MONTHS: {'01':'Jan', '02':'Feb', '03':'Mar', '04':'Apr', '05':'May', '06':'Jun', '07':'Jul', '08':'Aug', '09':'Sep', '10':'Oct', '11':'Nov', '12':'Dec', },
    EXPORT_LIST: [{ label: 'Csv', id: 'csv' }, { label: 'Excel', id: 'excel' }],
    IMPERSONATE_ROLES: ["6"],
    student_widget_1: { header: 'Course target and progress', title: "Student target and progress" },
    student_widget_2: { header: 'Assessments', title: "Student course assessments" },
    topics_saw: { header: "Topic strengths and weaknesses", title:"Topic strengths and weaknesses"},
    skills_saw: { header: "Skills strengths and weaknesses", title:"Skills strengths and weaknesses"},
    assessment_saw: { header: "Assessment objectives strengths and weaknesses", title:"AO strengths and weaknesses"},
    question_analysis: { header: "Question analysis", title:"Question analysis"},
    export_type_excel: "excel",
    group_widget_1: { header: 'Number of students on track to meet targets', title: "Students on track" },
    group_widget_2: { header: 'Assessments', title: "Assessments" },
    IMPERSONATE_ACTIVATE: 'updated',
    IMPERSONATE_DEACTIVATE: 'deleted',
    grade_widget_1: { header: 'Grade summary', title: "Grade summary" },
    grade_widget_3: { header: 'Grade analysis', title: "Grade analysis" },
    quesiton_widget_1: { header: 'Performance by question', title: "Question performance" },
    quesiton_widget_2: { header: 'Question analysis', title: "Question analysis" },
    grade_title: 'grade_report',
    question_title: 'question_analysis',
    group_title: 'group_summary',
    module_name_group: "Group",
    search_data_type_group_detail: "View",
    module_name_student: "Student",
    search_data_type_student_detail: "Summary",
    search_data_type_student_assessment: "Assessment",
    operation_type_csv: "Export-Csv",
    operation_type_excel: "Export-Excel",
    operation_type_print: "Screenshot",  
    group_title: 'group_summary'  ,
    topic_title: 'topic_analysis',
    skill_title: 'ao_skills_analysis',
    assessment_searchData_type: { "grade_report": "Grade", "question_summary": "Question", "topic_analysis": "Topic","ao_skills_analysis":"Skill"},
    student_detail_string_mapper : {
        "assessmentName": "assessment",
        "assessmentScore": "mark",
        "assessmentDateFormatted": "date",
        "assessmentDate":"date",
        "indicativeGradeValue": "indicativeGrade",
        "studentAssessmentMarks": "mark",
        "groupGradeAverage": "groupAverageIndicativeGrade",
        "groupAverageScore": "groupAverageMark",
        "indicativeGradeValue": "indicativeGrade",
        "yearGradeAverage": "yearAverageIndicativeGrade",
        "yearAverageScore": "yearAverageMark",
    },
    topics_assessment: { header: "Topic strengths and weaknesses", title: "Topic analysis" } ,
    skills_assessment: { header: "Skills strengths and weaknesses", title: "Skills analysis" },
    ao_assessment: { header: "Assessment objectives strengths and weaknesses", title: "AO analysis" }, 
};

export const studentWidgets = {
    "Topic strengths and weaknesses": "student_topic",
    "Skills strengths and weaknesses": "student_skill",
    "Assessment objectives strengths and weaknesses": "student_ao",
    "Question analysis": "student_analysis",
}

export const studentDetailsWidget = {
    "Course target and progress": "student_progress",
    "Assessments": "student_assessments",
}

export default EXP_CONSTS;